import { PAGINATION_MAPPINGS } from '../constants/table.constants';
import { dateToDateString } from '../lib/date.utils';
import { statusToString, typeToString } from '../lib/dossier.utils';
import { dossiers } from '../services/bff.api';

export const DOSSIERS_RESOURCE = {
  key: 'DOSSIERS_RESOURCE',
  detailPath: '/dossiers/:id',
  table: {
    defaultSort: '-createdAt',
    dataLocation: '_embedded.resourceList',
    dataTransform: (data) =>
      data?.map((i) => {
        return {
          ...i,
          deadline: dateToDateString(i?.deadline),
          createdAt: dateToDateString(i?.createdAt, true),
          status: statusToString(i.status),
          type: typeToString(i.type),
          startDate: dateToDateString(i?.startDate)
        };
      }),
    pageMapping: PAGINATION_MAPPINGS.DOSSIERS,
    fields: [
      { value: 'createdAt', label: 'Gemaakt op', show: true, order: -1 },
      { value: 'name', label: 'Dossiernaam', show: true, order: 0 },
      { value: 'status', label: 'Status', show: true, order: 1 },
      {
        value: 'dossierNumber',
        label: 'Dossiernr',
        show: false,
        order: 2
      },
      { value: 'school', label: 'School', show: true, blockSort: true, order: 3 },
      { value: 'branch', label: 'Vestiging', show: true, blockSort: true, order: 4 },
      { value: 'type', label: 'Type', show: true, order: 6 },
      { value: 'theme', label: 'Label', show: true, blockSort: true, order: 7 },
      { value: 'district', label: 'Wijk', show: true, order: 8 },
      { value: 'districtManager', label: 'Wijkverantwoordelijke', show: true, order: 9 },
      { value: 'startDate', label: 'Startdatum opvolging', show: true, order: 10 },
      { value: 'stakeholdersPartners', label: 'Betrokken partners', show: true, blockSort: true, order: 11 },
      { value: 'stakeholders', label: 'Betrokkenen', show: true, blockSort: true, order: 12 },
      { value: 'deadline', label: 'Volgende deadline', show: true, order: 13 },
      { value: 'typeSchool', label: 'Type school', show: false, blockSort: true, order: 14 }
    ],
    searchParams: [
      'query',
      'name',
      'dossierNumber',
      'school',
      'branch',
      'startDateFrom',
      'startDateTo',
      'deadlineFrom',
      'deadlineTo',
      'status',
      'type',
      'theme',
      // 'district',
      // 'districtManager',
      'requestedBy',
      'stakeholders',
      'stakeholdersPartners',
      'assigned'
    ]
  },
  single: {
    dataTransform: (data) => ({
      ...data,
      overview: { ...(data?.overview ?? {}), deadlineDate: dateToDateString(data?.overview?.deadlineDate) },
      status: statusToString(data.status),
      requestClarification:
        data?.requestClarification?.map((c) => ({
          ...c,
          date: dateToDateString(c.date),
          startTime: c.startTime ? c.startTime?.slice(0, 5) ?? '' : '',
          endTime: c.endTime ? c.endTime?.slice(0, 5) ?? '' : ''
        })) ?? [],
      caseTable: data?.caseTable?.map((ct) => ({ ...ct, date: dateToDateString(ct.date) })) ?? [],
      procedure: {
        ...(data?.procedure ?? {}),
        startDate: dateToDateString(data?.procedure?.startDate),
        endDate: dateToDateString(data?.procedure?.endDate),
        parts:
          data?.procedure?.parts?.map((p) => ({
            ...p,
            startDate: dateToDateString(p.startDate),
            endDate: dateToDateString(p.endDate)
          })) ?? []
      }
    })
  },
  api: {
    get: dossiers.search,
    getById: (id) => dossiers.getById(id)
  }
};
